import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets window scroll to top whenever the route (pathname) changes.
 * Mount once inside <BrowserRouter>. Returns null — has no DOM.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
